import { render, staticRenderFns } from "./ProjectsModal.vue?vue&type=template&id=6fb0c41a"
import script from "./ProjectsModal.vue?vue&type=script&lang=js"
export * from "./ProjectsModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectsModal.vue?vue&type=style&index=0&id=6fb0c41a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports